import React, {useEffect, useState} from "react";
import {
  Layout,
  Menu,
  Divider,
  Spin,
  message
} from "antd";
import { Link } from "react-router-dom";
import * as AntIcon from "@ant-design/icons";
import useAuth from "utils/auth/hooks";
import util from "helpers/util";
import matahariLogo from 'assets/images/mataharilogo_white.png';
import promotions from "constants/api/promotions";

const { Sider } = Layout;

const { HomeOutlined } = AntIcon;

export default function Sidebar(props) {
  const { methods, data } = useAuth();
  const [loading, setLoading] = useState(false);

  function etpPromotionClick(url){
    setLoading(true);

    promotions.sendSSOPayloadToETP()
      .then(res => {
        if(res.success){
          window.open(url, '_blank');
        }
        else{
          message.error(res.message);
        }
      })
      .catch(err => {
        util.displayApiError(err);
      })
      .finally(() => {
        setLoading(false);
      })
  }

  return (
    <Sider
      style={{
        overflow: "auto",
        height: "auto",
      }}
    >
      <div style={{height:'46px', width:'100%', marginTop:'9px', marginBottom:'9px'}}>
        <img src={matahariLogo} style={{height:'100%', width:'100%', objectFit:'contain' }} />
      </div>
      <Divider
        style={{ borderTop: "1px solid red", marginTop: 0, marginBottom: 10 }}
      />
      
      <Spin size="middle" tip="Loading..." spinning={loading}>
        <Menu theme="dark" mode="inline">
          <Menu.Item key={'home'} icon={<HomeOutlined />}><Link to={`/Home`} replace={true}>Home</Link></Menu.Item>
          {props.allowedMenus.map((m, i) => renderMenuRecursive(m, i, data, etpPromotionClick))}
        </Menu>
      </Spin>
    </Sider>
  );
}

function renderMenuRecursive(m, index, data, onEtpPromotionClick){
  const IconL1 = AntIcon[m.icon] ?? AntIcon.LineOutlined;

  const keycloakToken = data?.userData?.keycloakToken;
  const username = data?.userData?.userInfo?.username;

  const etpUrl = `${process.env.REACT_APP_BASE_ETP}HomePage.aspx?sso_token="yes"&jwt="${keycloakToken}"&username="${username}"`;

  if(m.child.length > 0){
    return(
      <Menu.SubMenu key={m.display} title={m.display} icon={<IconL1 />}>
        {m.child.map((m, i) => renderMenuRecursive(m, i, data))}
      </Menu.SubMenu>
    );
  }
  else{
    return(
        <Menu.Item key={m.display} icon={<IconL1 />}>
          {process.env.REACT_APP_ENABLE_INTEGRATION === 'true' && m.url === 'Promotion' && keycloakToken ? 
            <Link to={{pathname: etpUrl}} onClick={(e) => { 
                e.preventDefault();
                onEtpPromotionClick(etpUrl); 
              } 
            }>
              {m.display}
            </Link>
            : <Link to={`/${m.url}`} replace={true}>{m.display}</Link>
          }
        </Menu.Item>
    );
  }
}